import Vue from 'vue'
import Vuex from 'vuex'
import bookData from '@/assets/data/chapters.yml'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    chapters: bookData
  },
  mutations: {},
  actions: {},
  getters: {
    chapter: state => {
      return state.chapters.find(chapter => {
        return chapter.id === Number(state.route.params.id)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js